<template lang="pug">
.work-sessions
  NotesDialog(
    :show="showNotesDialog"
    :notes="selectedNotes"
    :project-name="projectName"
    @close="closeNotesDialog"
  )
  table.table-hover.reports-table.work_sessions-report-table.table
    WorkSessionsReportTableHeader(:show-date-user-placeholder="showDateUserPlaceholder")
    // eslint-disable vue/require-v-for-key
    template(v-for="section in tableData.sections")
      tbody.grouping-header
        tr
          th(colspan="100%")
            template(v-if="walker.main_type === 'user'")
              ReportTableAvatar(
                avatar-style="medium"
                :user-id="section.main_id"
                :url="section.rows[0].record.avatar_url"
              )
              | {{ section.main }}
            template(v-else-if="walker.main_type === 'project' || walker.main_type === 'client'")
              template(v-if="walker.main_type === 'client' && section.main == null")
                span.text-lighter No client
              template(v-else)
                ReportTableAvatarInitial(
                  :text="section.main"
                  class-modifier="avatar"
                )
                | {{ section.main }}
            template(v-else-if="walker.main_type === 'date'")
              .grouping-user(v-if="groupByDateUser")
                ReportTableAvatar(
                  avatar-style="medium"
                  :user-id="section.rows[0].record.sub_id"
                  :url="section.rows[0].record.avatar_url"
                )
                | {{ section.rows[0].record.sub }}
              | {{ formatDateLabel(section.main) }}
      // This total row is used only for "groupByDateUser" option
      // Add different set of "td" for another group_by view
      tbody.grouping-total(v-if="groupByDateUser")
        tr(
          :class="{ 'is-expanded': showToggledSectionById(section.uuid) }"
          @click="toggleSection(section)"
        )
          td
            span.expand-rows-toggle(:class="{ 'is-expanded': showToggledSectionById(section.uuid) }")
              i.hi.hi-caret
              span Total
          td(v-for="n in columnsToFillTotal" :key="'pad-' + n")
          td(v-if="tableShowStarted") {{ formattedTime(minTimestamp(section, 'started')) }}
          td(v-if="tableShowStopped") {{ formattedTime(maxTimestamp(section, 'stopped')) }}
          td(v-if="tableShowDuration") {{ $filters.formatDuration(section.total.duration || 0, 'user', null, false, true) }}
          td(v-if="tableShowActivity") {{ $filters.percentage(section.total.overall || 0, section.total.input_tracked || 0) }}
          td(v-if="tableShowNotes")

      tbody.tbody(v-show="showToggledSectionById(section.uuid)")
        tr(
          v-for="(row, idx) in section.rows"
          :key="idx"
          :class="{ 'has-border': row.sub_show_data }"
        )
          td(v-if="showDateUserPlaceholder")
          template(v-if="walker.sub_show")
            td(v-if="row.sub_show_data")
              template(v-if="walker.sub_type === 'date'")
                | {{ formatDateLabel(row.record.sub) }}
              template(v-else-if="walker.sub_type === 'user'")
                ReportTableAvatar(
                  avatar-style="medium"
                  :user-id="row.record.sub_id"
                  :url="row.record.avatar_url"
                )
                | {{ row.record.sub }}
              template(v-else-if="walker.sub_type === 'project' || walker.sub_type === 'client'")
                template(v-if="walker.sub_type === 'client' && row.record.sub == null")
                  span.text-lighter No client
                template(v-else)
                  ReportTableAvatarInitial(
                    :text="row.record.sub"
                    class-modifier="avatar"
                  )
                  | {{ row.record.sub }}
            td(v-else)

          template(v-if="walker.third_show")
            td(v-if="row.third_show_data")
              template(v-if="walker.third_type === 'date'")
                | {{ formatDateLabel(row.record.third) }}
              template(v-else-if="walker.third_type === 'user'")
                ReportTableAvatar(
                  avatar-style="medium"
                  :user-id="row.record.third_id"
                  :url="row.record.avatar_url"
                )
                | {{ row.record.third }}
              template(v-else-if="walker.third_type === 'project' || walker.third_type === 'client'")
                template(v-if="walker.third_type === 'client' && row.record.third == null")
                  span.text-lighter No client
                template(v-else)
                  ReportTableAvatarInitial(
                    :text="row.record.third"
                    class-modifier="avatar"
                  )
                  | {{ row.record.third }}
            td(v-else)

          template(v-if="walker.fourth_show")
            td(v-if="row.fourth_show_data")
              template(v-if="walker.fourth_type === 'user'")
                ReportTableAvatar(
                  avatar-style="medium"
                  :user-id="row.record.fourth_id"
                  :url="row.record.avatar_url"
                )
                | {{ row.record.fourth }}
              template(v-else-if="walker.fourth_type === 'date'")
                | {{ formatDateLabel(row.record.fourth) }}
              template(v-else-if="walker.fourth_type === 'project' || walker.fourth_type === 'client'")
                template(v-if="walker.fourth_type === 'client' && row.record.fourth == null")
                  span.text-lighter No client
                template(v-else)
                  ReportTableAvatarInitial(:text="row.record.fourth")
                  | {{ row.record.fourth }}
            td(v-else)

          td(v-if="tableShowTasks") {{ row.record.t_summary }}
          td(v-if="tableShowManualTime") {{ row.record.manual }}
          td(v-if="tableShowStarted") {{ formattedTime(row.record.started) }}
          td(v-if="tableShowStopped") {{ formattedTime(row.record.stopped) }}
          td(v-if="tableShowDuration") {{ $filters.formatDuration(row.record.duration, 'user', null, false, true) }}
          td(v-if="tableShowActivity") {{ row.record.activity }}
          td.long-text-cell(
            v-if="tableShowNotes"
            :set="(notes[row.record.id] = timeEntryNotes(row))"
          )
            // FIXME: As we are reusing the same walker of other reports, we end up with an array of notes
              prepared for the T&A report, on that report notes are grouped by daily activities and on this report
              we need to disaggregate them based on time entries.
              The +timeEntryNotes+ method does the trick but the performance might not be the best.
            a.clickable.strong(
              v-if="notes[row.record.id].length > 1"
              @click="openNotesDialog(row, notes[row.record.id][0].project_name)"
            )
              | {{ notes[row.record.id].length }} Notes
            span(
              v-else-if="notes[row.record.id].length == 1"
              v-popover:left
              :data-content="notes[row.record.id][0].description"
            )
              | {{ notes[row.record.id][0].description }}
            span(v-else)
              |
    // eslint-enable vue/require-v-for-key
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { formatTime } from '~/utils/time_utils';
import WorkSessionsReportTableHeader from './WorkSessionsReportTableHeader.vue';
import NotesDialog from '~/components/reports/time_and_activities/NotesDialog.vue';

export default {
  name: 'WorkSessionsReportTable',
  components: { WorkSessionsReportTableHeader, NotesDialog },
  props: {
    tableData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showNotesDialog: false,
      projectName: null,
      notes: {},
      selectedNotes: [],
    };
  },
  computed: {
    ...mapGetters([
      'groupByDateUser',
      'reportQuery',
      'showToggledSectionById',
      'tableShowClient',
      'tableShowManualTime',
      'tableShowStarted',
      'tableShowStopped',
      'tableShowDuration',
      'tableShowActivity',
      'tableShowNotes',
      'tableShowTasks',
      'virtualTableItemSize',
      'walker',
    ]),
    ...mapState({
      organization: 'organization',
    }),
    // Used to prefill empty columns in total view
    emptyTotalColumns() {
      return this.groupByDateUser ? [
        this.walker.third_show,
        this.walker.fourth_show,
        this.tableShowTasks,
        this.tableShowManualTime,
      ].filter(Boolean) : [];
    },
    showDateUserPlaceholder() {
      return this.groupByDateUser && this.emptyTotalColumns.length === 0;
    },
    columnsToFillTotal() {
      return Math.max(0, this.emptyTotalColumns.length - 1);
    },
  },
  methods: {
    toggleSection(section) {
      this.$store.dispatch('toggleSection', {
        section_id: section.uuid,
        section_count: this.tableData.sections.length,
      });
    },
    formatDateLabel(value) {
      if (value === 'summed_date') {
        return (
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date)) +
          ' - ' +
          TimeUtils.format_date(TimeUtils.parse_internal_date(this.$store.state.report_query.date_end))
        );
      }

      return TimeUtils.format_date(TimeUtils.parse_internal_date(value));
    },
    formattedTime(time) {
      return formatTime(time, { showSeconds: 'user', timezone: this.organization.time_zone_id });
    },
    openNotesDialog(row, project) {
      this.selectedNotes = this.notes[row.record.id];
      this.projectName = project;
      this.showNotesDialog = true;
    },
    closeNotesDialog() {
      this.showNotesDialog = false;
    },
    timeEntryNotes(row) {
      const started = moment(row.record.started);
      const stopped = moment(row.record.stopped);

      return row.notes.filter((note) => moment(note.recorded_at).isBetween(started, stopped, undefined, '[)'));
    },
    minTimestamp(section, fieldName) {
      return this.findExtremeTimestamp(section, fieldName, (a, b) => a < b);
    },
    maxTimestamp(section, fieldName) {
      return this.findExtremeTimestamp(section, fieldName, (a, b) => a > b);
    },
    // Finds min or max timestamp from ISO 8601 formatted strings (e.g., "2024-01-15T10:30:00Z")
    findExtremeTimestamp(section, fieldName, compareFn) {
      const values = section.rows
          .map(row => row.record[fieldName])
          .filter(Boolean);

      return values.length === 0
          ? null
          : values.reduce((extreme, curr) => compareFn(curr, extreme) ? curr : extreme);
    }
  },
};
</script>
